import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DepartmentLogosActions} from '../store';
import {DepartmentLogosSelectors} from '../store/selectors';

@Injectable()
export class DepartmentLogosLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadDepartmentLogosDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadDepartmentLogosDone() {

    return this.store.pipe(
      select(DepartmentLogosSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(DepartmentLogosActions.ReadDepartmentLogos());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
